import React from 'react';
import { FormattedNumber } from 'react-intl';
import { Table, Label } from 'semantic-ui-react';
import ActionMenu from '../../components/ActionMenu';
import { dateTimeCell } from '../../utilities/dateUtils';

const currencyProps = (price) => ({
  currency: 'USD',
  style: 'currency',
  minimumFractionDigits: 0,
  value: price,
});

const ListRowV2 = (actionHandler) => (guaranteePurchase) => {
  const rowMenuOptions = [
    { key: 1, text: 'Edit', value: 'Edit' },
    { key: 2, text: 'Extend Guarantee', value: 'Extend Guarantee' },
    { key: 3, text: 'Cancel Guarantee', value: 'Cancel Guarantee' },
    { key: 4, text: 'Status History', value: 'Audit' },
    { key: 5, text: 'Vehicle Status Tracker', value: 'Vehicle Status Tracker' },
  ];

  const {
    externalId,
    guaranteeStatus,
    vin,
    leftLot,
    expireGuarantee,
    guaranteedAt,
    dealerNumber,
    auctionCode,
    saleNumber,
    saleLane,
    saleRun,
    modelYear,
    make,
    model,
    odometer,
    salePrice,
    productName,
    guaranteePrice,
    partner,
    paymentKind,
  } = guaranteePurchase;

  const auctionInfo = [auctionCode, saleNumber, saleLane, saleRun].join(' / ');
  const vehicle = [modelYear, make, model].filter(Boolean).join(' ');

  const handleActionChange = (e, { value }) => {
    e.preventDefault();
    actionHandler(value, guaranteePurchase);
  };

  const labels = [];
  if (leftLot) {
    labels.push(
      <Label key="left lot" color="red" horizontal>
        Left Lot
      </Label>,
    );
  }
  if (expireGuarantee) {
    labels.push(
      <Label key="Expired" color="red" horizontal>
        Expired
      </Label>,
    );
  }

  return (
    <Table.Row key={externalId} data-testid="purchase-row">
      <Table.Cell>
        {vin} {labels}
      </Table.Cell>
      <Table.Cell>{externalId}</Table.Cell>
      <Table.Cell>{dateTimeCell(guaranteedAt)}</Table.Cell>
      <Table.Cell data-testid="dealer-number-cell">{dealerNumber}</Table.Cell>
      <Table.Cell>{auctionInfo}</Table.Cell>
      <Table.Cell>{vehicle}</Table.Cell>
      <Table.Cell>{odometer}</Table.Cell>
      <Table.Cell>
        {salePrice != null &&
          React.createElement(FormattedNumber, currencyProps(salePrice))}
      </Table.Cell>
      <Table.Cell data-testid="status-cell">{guaranteeStatus}</Table.Cell>
      <Table.Cell data-testid="product-cell">{productName}</Table.Cell>
      <Table.Cell>
        {guaranteePrice != null &&
          React.createElement(FormattedNumber, currencyProps(guaranteePrice))}
      </Table.Cell>
      <Table.Cell data-testid='partner-cell'>{partner}</Table.Cell>
      <Table.Cell>{paymentKind}</Table.Cell>
      <Table.Cell>
        <ActionMenu options={rowMenuOptions} onChange={handleActionChange} />
      </Table.Cell>
    </Table.Row>
  );
};

export default ListRowV2;
